<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" tag="div" class="height-100">
    <form @submit.prevent="handleSubmit(onSubmit)" class="height-100">
      <v-layout fill-height column justify-space-between>
        <!-- column 상단 시작 -->
        <v-flex>
          <!-- 페이지 제목 -->
          <div class="page-title-box mb-8">
            <p>계정 정보를 연동하시면,</p>
            <h1>
              바로 사용 가능한<br />
              한도를 설정해 드려요!
            </h1>
          </div>

          <!-- 플랫폼별 동적 입력란 -->
          <v-fade-transition>
            <section v-if="mall && load">
              <div class="input-box">
                <p>선택한 플랫폼</p>
                <v-layout>
                  <v-text-field v-model="mall.name" disabled outlined hide-details />
                  <v-btn
                    width="100"
                    depressed
                    class="white--inset"
                    @click="$router.push({ name: 'signup/mall' })"
                  >
                    <b>변경</b>
                  </v-btn>
                </v-layout>
              </div>

              <FormValidationInput
                v-for="(input, index) in formInputs"
                :key="index"
                :inputValue.sync="form[input.key]"
                :valid="{ name: input.label, rules: 'required' }"
                :title="input.label"
                :placeholder="input.placeholder"
                :tabindex="String(input.order)"
                :autofocus="index === 0"
                :type="input.isPassword ? 'password' : 'text'"
                :autocomplete="input.isPassword ? 'current-password' : 'off'"
                :passwordShow.sync="formPasswordShow[input.key]"
              />

              <v-layout v-if="hasAdminUrl" justify-center class="mt-n2 mb-4">
                <v-btn
                  text
                  small
                  target="_blank"
                  height="24"
                  :href="adminUrl[mall.code]"
                  id="btn__Nl1V7isWnkaz5EECa7GBfA"
                >
                  <span
                    class="color--gray-70"
                    style="border-bottom: 1px solid #7a7f86; line-height: 1"
                  >
                    아이디 / 비밀번호를 잊으셨나요?
                  </span>
                </v-btn>
              </v-layout>
            </section>
          </v-fade-transition>
        </v-flex>
        <!-- column 상단 끝 -->

        <!-- column 하단 시작 -->
        <v-fade-transition>
          <section v-if="load" class="page-footer-column">
            <p>
              *
              <span class="font-weight-bold primary--text">먼저 받을 수 있는 정산 금액 확인</span>을
              위해<br />
              쇼핑몰에 매출 및 선정산 이용 내역을 확인 할 예정이에요.
            </p>
            <BasicButton
              block
              large
              type="submit"
              height="52"
              :disabled="invalid || loading"
              :loading="loading"
              id="btn__4JSopGHpGEatUp4budDH5Q"
            >
              {{ isTwoFactorAuth ? '다음' : '연동하기' }}
            </BasicButton>
          </section>
        </v-fade-transition>
        <!-- column 하단 끝 -->
      </v-layout>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormValidationInput from '@/components/common/form/FormValidationInput.vue'
import { toCamel } from '@/util'

export default {
  components: { FormValidationInput },
  data() {
    return {
      form: {}, // key = field.fieldName
      formPasswordShow: {}, // key = field.fieldName
      loading: false,

      load: false,

      adminUrl: {
        brandi: 'https://admin.brandi.co.kr/login',
        ably: 'https://my.a-bly.com/reset-password',
        zigzag: 'https://partners.kakaostyle.com/login',
        brich: 'https://b-flow.co.kr/login#/',
        hiver: 'https://admin.hiver.co.kr/login#',
      },
    }
  },
  computed: {
    ...mapState('mall', ['providers']),
    ...mapGetters('mall', ['providersObj']),

    mall() {
      return this.providersObj?.[this.$route.params.provider]
    },

    hasAdminUrl() {
      return Object.getOwnPropertyNames(this.adminUrl).includes(this.mall?.code)
    },

    formInputs() {
      const credentials = this.mall?.credentialsFields?.filter((e) => e.isHidden === false)
      if (!credentials) return []

      const result = credentials.map((field) => {
        const key = toCamel(field.fieldName)
        return {
          key,
          value: null,
          label: field.label,
          placeholder: field.placeholder,
          isPassword: field.isPassword,
          order: field.order,
        }
      })

      result.sort((a, b) => a.order - b.order)

      return result
    },

    registerForm() {
      return {
        provider: this.mall?.code,
        ...this.form,
      }
    },

    isTwoFactorAuth() {
      return this.mall?.twoFactorAuth !== 'none'
    },
  },
  async created() {
    if (!this.providers) {
      await this.getMallProviders()
    }
  },
  mounted() {
    setTimeout(() => {
      this.load = true
    }, 200)
  },
  methods: {
    ...mapActions('mall', ['getMallProviders', 'addMalls']),

    async onSubmit() {
      if (this.loading) return

      try {
        this.loading = true
        await this.addMalls(this.registerForm)
        await this.$router.push({ name: 'signup/complete' })
      } catch (e) {
        // 아이디 비밀번호 일치 및 2차인증 필요
        if (e.status === 400 && e.errors?.[0]?.code === 'two_factor_auth_required') {
          await this.$router.push({
            name: 'signup/mall/two-factor-auth',
            params: { provider: this.mall.code, signinForm: this.registerForm },
          })
          return
        }

        throw e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
